import { useIntl } from 'react-intl';

import { isNewRecordingAssetEpisode, RecordingAsset, RecordingSettings } from '@kaltura-ott/tvpil-shared';

import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import { isStandaloneRecordingAsset } from '../../utils';

const translationId = 'Rail.RailCard';

export function useNewEpisodeBadge(recording: RecordingAsset) {
  const intl = useIntl();

  const { settings } = useWidgetContext<RecordingAsset, RecordingSettings>();

  if (!settings.newEpisodeRetention || isStandaloneRecordingAsset(recording)) {
    return undefined;
  }

  const expiredInDays = isNewRecordingAssetEpisode(recording, settings.newEpisodeRetention);

  if (!expiredInDays) {
    return undefined;
  }

  return intl.formatMessage({ id: `${translationId}.newEpisodeBadge`, defaultMessage: 'New Episode' });
}
